import React, { useEffect } from 'react';
import { GlobalHeader } from '@quickenloans-ui-suite/global-head';
import { SlideUpBanner } from '@quickenloans-ui-suite/components/slide-up-banner';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import * as buildEnvs from '../../../../_envs.json';
import Footer from '../Footer';
import { testAttributes } from './Constants';
import { mainContentWithGlobal, rootPath } from './Layout.module.scss';
import useBottomDrawer from '../../../utilities/useBottomDrawer';
import { getNodeFeatureFlag } from '../../../context/featureFlags/getNodeFeatureFlag';
import { useDetectEndemicAdChange } from '../../../utilities/useDetectEndemicAdChange';

const bottomDrawerEnabled = getNodeFeatureFlag('BOTTOM_DRAWER');

const Layout = ({
    headerProps,
    footerProps,
    isPreview = false,
    children,
}) => 
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const { bottomDrawerOffset, ...bottomDrawerProps } = useBottomDrawer();
    bottomDrawerProps.environment = activeEnv;

    const { globalNav, globalAccount } = headerProps;
    const globalHeaderKey = useDetectEndemicAdChange(globalNav);
    const renderedFooterProps = {
        ...footerProps
    }

    const offsetStyle = {
        '--ql-bottom-offset-mobile': `${bottomDrawerOffset?.mobile}`,
        '--ql-bottom-offset-desktop': `${bottomDrawerOffset?.desktop}`,
    };

    if (!Array.isArray(renderedFooterProps?.disclosure)) 
    {
        renderedFooterProps.disclosure = [];
    }

    useEffect(() => 
    {
        if (typeof window !== 'undefined') 
        {
            Promise.resolve().then(() => 
            {
                window.scrollTo(0, 0);
            });
        }
    }, []);

    return (
        <>
            {bottomDrawerEnabled && <SlideUpBanner {...bottomDrawerProps} />}
            <app-root
                class={`${rootPath} layout_root ${isPreview ? 'isPreview' : ''}`}
                data-testid={testAttributes.PAGE_ROOT}
                style={offsetStyle}
            >
                <GlobalHeader
                    key={globalHeaderKey}
                    hostPlatform="gatsby"
                    LinkComponent={Link}
                    environment={buildEnvs[activeEnv].GN_BBF_ENV}
                    defaultMainMenu={{ globalNav, globalAccount }}
                />
                <main role="main" className={mainContentWithGlobal} data-testid={testAttributes.MAIN_CONTAINER}>
                    {children}
                </main>
                <Footer {...renderedFooterProps} />
            </app-root>
        </>
    )
}

Layout.propTypes = {
    /** header = menu items, logo, CTA */
    headerProps: PropTypes.object.isRequired,
    /** footer = legalese, bottom menu */
    footerProps: PropTypes.object.isRequired,
    /** add className that displays Preview watermark over page */
    isPreview: PropTypes.bool,
    /** children: content of page */
    children: PropTypes.node.isRequired,
    /** header = menu items, logo, CTA */
    breadcrumbProps: PropTypes.array,
    /** hasHero = change the breadcrumb margin to match with hero design */
    hasHero: PropTypes.bool
}

export default Layout;
